import React, { useEffect, useState } from "react";
import TopNav from "../../components/TopNav";
import BottomNav from "../../components/BottomNav";
import Footer from "../../components/footer/Footer";
import api_url from "../../ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const submit = async () => {
    const fullName = document.getElementById("fullName");
    const phone = document.getElementById("phone");
    const city = document.getElementById("city");
    const email = document.getElementById("email");
    const yourMessage = document.getElementById("yourMessage");
    const subject = document.getElementById("subject");

    if (!fullName.value?.trim()) return toast.error("Please enter your name");
    if (!phone.value?.trim()) return toast.error("Please enter your phone");
    if (!email.value?.trim()) return toast.error("Please enter your email");
    if (!subject.value?.trim()) return toast.error("Please enter a subject");
    if (!city.value?.trim()) return toast.error("Please enter your city");
    if (!yourMessage.value?.trim()) return toast.error("Please enter a message");

    const params = {
      fullName: fullName.value.trim(),
      phone: phone.value.trim(),
      email: email.value.trim(),
      yourMessage: yourMessage.value.trim(),
      city: city.value.trim(),
      subject: subject.value.trim(),
    };

    try {
      setSubmitting(true);
      const res = await axios.post(`${api_url}contact/create`, params);
      if (res.data.status === "ok") {
        toast.success("Your message submitted successfully!");
        setTimeout(() => window.location.reload(), 1500);
      } else {
        toast.error(res.data.message || "Error submitting your message");
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Error submitting your message");
    } finally {
      setSubmitting(false);
    }
  };

  const mapAddress =
    "Makkaan.com, 2nd Floor Jackson Heights, GT Rd, Morgah, Rawalpindi, 46000";

  return (
    <>
      <TopNav />
      <BottomNav />

      {/* HERO (centered) */}
      <section
        className="position-relative"
        style={{
          background:
            "linear-gradient(135deg, #383c4bff 0%, #070d2aff 100%)",
        }}
      >
        <div className="container text-white py-5 text-center">
          {/* Simple centered breadcrumb */}
          <div className="small mb-2" style={{ opacity: 0.95 }}>
            <a href="/" className="text-white text-decoration-none">
              Home
            </a>{" "}
            / <span>Contact Us</span>
          </div>

          <h1 className="fw-bold mb-1">Contact Us</h1>
          <p className="mb-0" style={{ maxWidth: 760, margin: "0 auto", opacity: 0.95 ,color:"white" }}>
            We’re here to help. Reach out for inquiries, partnerships, or a quick
            chat about your real-estate goals.
          </p>
        </div>
      </section>

      {/* MAIN CONTENT (map stays below) */}
      <div className="container">
        <div className="row g-5 align-items-start mt-4">
          {/* LEFT: Info */}
          <div className="col-lg-5" style={{ padding: "60px" }}>

            <h2 className="fw-bold" style={{ fontSize: 28, lineHeight: "1.15" }}>
              Let&apos;s Talk About Everything!
            </h2>
            <p className="text-muted" style={{ fontSize: 20 }}>
              Have a question or feedback? Feel at ease to contact us.
            </p>

            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
              <div className="list-group list-group-flush">
                <div className="list-group-item p-4">
                  <div className="d-flex align-items-center">
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-3"
                      style={{
                        width: 44,
                        height: 44,
                        background: "rgba(77,183,73,0.12)",
                        border: "1px solid rgba(77,183,73,0.25)",
                      }}
                    >
                      <img
                        src={require("./../../img/ads/phone-call.png")}
                        alt="Phone"
                        style={{ width: 22, height: 22 }}
                      />
                    </span>
                    <div className="ms-3">
                      <div className="fw-semibold">Call</div>
                      <div className="text-muted small">0331-1111049</div>
                    </div>
                  </div>
                </div>

                <div className="list-group-item p-4">
                  <div className="d-flex align-items-center">
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-3"
                      style={{
                        width: 44,
                        height: 44,
                        background: "rgba(77,183,73,0.12)",
                        border: "1px solid rgba(77,183,73,0.25)",
                      }}
                    >
                      <img
                        src={require("./../../img/ads/social.png")}
                        alt="WhatsApp"
                        style={{ width: 22, height: 22 }}
                      />
                    </span>
                    <div className="ms-3">
                      <div className="fw-semibold">WhatsApp</div>
                      <div className="text-muted small">0331-1111049</div>
                    </div>
                  </div>
                </div>

                <div className="list-group-item p-4">
                  <div className="d-flex align-items-center">
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-3"
                      style={{
                        width: 44,
                        height: 44,
                        background: "rgba(93, 220, 88, 0.12)",
                        border: "1px solid rgba(77,183,73,0.25)",
                      }}
                    >
                      <img
                        src={require("./../../img/ads/email-contact.png")}
                        alt="Email"
                        style={{ width: 22, height: 22 }}
                      />
                    </span>
                    <div className="ms-3">
                      <div className="fw-semibold">Email</div>
                      <div className="text-muted small">info@makkaan.com</div>
                    </div>
                  </div>
                </div>

                <div className="list-group-item p-4">
                  <div className="d-flex align-items-start">
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-3"
                      style={{
                        width: 44,
                        height: 44,
                        background: "rgba(77,183,73,0.12)",
                        border: "1px solid rgba(77,183,73,0.25)",
                      }}
                    >
                      <img
                        src={require("./../../img/ads/location-contact.png")}
                        alt="Location"
                        style={{ width: 22, height: 22 }}
                      />
                    </span>
                    <div className="ms-3">
                      <div className="fw-semibold">Address</div>
                      <div className="text-muted small">
                        2nd Floor Jackson Heights, G.T. Rd, Rawalpindi, 46000
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p className="mt-4 text-muted" style={{ fontSize: 16 }}>
              Hello there! If you&apos;d like to ask us something, you can get in touch with us here!
              We&apos;d love to address any and all concerns you may have.
            </p>
          </div>

          {/* RIGHT: Form — light green background */}
          <div className="col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-4 p-4 p-md-5"
              style={{ backgroundColor: "#ccf3ccff" }} // light green
            >
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label text-muted small mb-1" htmlFor="fullName">
                    Your Name
                  </label>
                  <input id="fullName" type="text" className="form-control p-3 rounded-3" placeholder="e.g. John Doe" />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1" htmlFor="phone">
                    Phone Number
                  </label>
                  <input id="phone" type="tel" maxLength={20} className="form-control p-3 rounded-3" placeholder="+92 331 1111049" />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1" htmlFor="email">
                    Email
                  </label>
                  <input id="email" type="email" className="form-control p-3 rounded-3" placeholder="you@example.com" />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1" htmlFor="city">
                    City
                  </label>
                  <input id="city" type="text" className="form-control p-3 rounded-3" placeholder="Rawalpindi" />
                </div>

                <div className="col-md-6">
                  <label className="form-label text-muted small mb-1" htmlFor="subject">
                    Subject
                  </label>
                  <input id="subject" type="text" className="form-control p-3 rounded-3" placeholder="How can we help?" />
                </div>

                <div className="col-12">
                  <label className="form-label text-muted small mb-1" htmlFor="yourMessage">
                    Message
                  </label>
                  <textarea id="yourMessage" rows={4} className="form-control p-3 rounded-3" placeholder="Write your message here..." />
                </div>

                <div className="col-12 pt-2">
                  <button
                    className="btn w-100 py-3 rounded-3 text-white"
                    style={{
                      background: "linear-gradient(135deg, #47c343ff 0%, #2cb149ff 100%)",
                      boxShadow: "0 8px 18px rgba(45, 155, 73, 0.25)",
                    }}
                    onClick={submit}
                    disabled={submitting}
                  >
                    {submitting ? "Sending..." : "SEND YOUR QUESTION"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAP (kept BELOW; now full width edge-to-edge) */}
      </div>

      <section className="container-fluid px-0">
        <div className="w-100" style={{ overflow: "hidden" }}>
          <iframe
            title="Makkaan.com Location"
            src={`https://www.google.com/maps?q=${encodeURIComponent(mapAddress)}&output=embed`}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{
              border: 0,
              width: "100vw",
              height: "430px",
              display: "block",
            }}
            allowFullScreen
          />
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
